// import actions from './actions';

const initState = {
  hiveAction: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    default:
      return state;
  }
}
